<template>
  <unroll-element
    :title="stringified_dict(metavariables_poid)"
    :available="probability_instantiated"
    :start_opened="probability_instantiated"
  >
    <div v-if="probability_instantiated">
      <true-probability-chart
        :project_id="project_id"
        :poid="probability_poid"
      />
    </div>
  </unroll-element>
</template>

<script>
import _ from 'lodash'

import {
  brick_mixin,
  subscription_mixin,
  metavariables_tracking_info_mixin,
  brick_generic_modelgenerator_tracking_info_mixin,
} from '@/components/mixin.js'

import UnrollElement from './unroll_element.vue'
import TrueProbabilityChart from '@/components/true_probability_chart.vue'

// *****************************************************************************

export default {
  name: 'BrickGenericModelgeneratorSubcomponentProbabilityChart',
  components: { UnrollElement, TrueProbabilityChart },
  mixins: [
    brick_mixin,
    subscription_mixin,
    metavariables_tracking_info_mixin,
    brick_generic_modelgenerator_tracking_info_mixin,
  ],
  props: ['brick_id', 'project_id', 'metavariables_poid'],
  computed: {
    probability_poid() {
      let res = this.metavariables_tracking_info.probability_poid || -1
      return res
    },
    probability_instantiated() {
      let res = this.fetch_poid_status(
        `probability_instantiated_${this.probability_poid}`,
        this.probability_poid
      )
      return res
    },
  },
  watch: {
    probability_instantiated: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          if (nv) {
            this.$emit('is_instantiated')
          }
        }
      },
    },
  },
}
</script>
